import { styled } from "styled-components";

export const QuestionEditstyled = styled.div`
  font-size: 24px;
`;
